import styled from 'styled-components';
import { COLORS } from '../../consts/colors';

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 16px;
`;

export const LabelText = styled.span`
  display: block;
  font-weight: 400;
  margin-bottom: 4px;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
`;

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: rgba(3, 123, 234, 0.08);
  border: 1px solid ${COLORS.LIGHT_BLUE};
  border-radius: 20px;
  padding: 6px 14px;
  gap: 8px;
  color: ${COLORS.DARKER_GRAY};
`;

export const ChipText = styled.span`
  font-weight: 400;
`;

export const ChipRemove = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border-radius: 50%;
  color: ${COLORS.DARK_GRAY};
  line-height: 1;

  &:hover {
    color: ${COLORS.LIGHT_RED};
    background-color: rgba(183, 52, 52, 0.1);
  }
`;


export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${COLORS.WHITE};
  border: 1px solid ${COLORS.DARK_GRAY};
  border-top: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
  direction: rtl;
`;

export const DropdownItem = styled.div`
  padding: 12px 15px;
  cursor: pointer;
  font-family: "NextExitRound", Arial;
  font-size: 24px;
  color: ${COLORS.DARKER_GRAY};
  border-bottom: 1px solid ${COLORS.EXTRA_LIGHT_GRAY};
  transition: background-color 0.15s;

  &:hover {
    background-color: ${COLORS.EXTRA_LIGHT_GRAY};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const AddNewItem = styled.div`
  padding: 12px 15px;
  cursor: pointer;
  font-family: "NextExitRound", Arial;
  font-size: 24px;
  color: ${COLORS.LIGHT_BLUE};
  border-top: 1px dashed ${COLORS.DARK_GRAY};
  background-color: rgba(3, 123, 234, 0.05);
  transition: background-color 0.15s;

  &:hover {
    background-color: ${COLORS.EXTRA_LIGHT_GRAY};
  }
`;

export const EmptyMessage = styled.div`
  padding: 12px 15px;
  font-family: "NextExitRound", Arial;
  font-size: 24px;
  color: ${COLORS.DARK_GRAY};
  text-align: center;
`;
